/* PLATANE motion: scroll reveal + Ken Burns start after image load */
(function () {
  try {
    document.documentElement.classList.add('pl-js');

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- Ken Burns: start animation only after the image has loaded ---- */
    function armKenBurns(img, seconds) {
      img.classList.add('pl-loaded');
      if (reduce) return;
      img.classList.add('pl-kenburns-active');
      img.style.animationDuration = seconds + 's';
    }
    var kbImgs = document.querySelectorAll('.slideshow__media img, .pl-anniversary__hero-img');
    for (var i = 0; i < kbImgs.length; i++) {
      (function (img) {
        var secs = img.closest('.pl-anniversary__hero') ? 20 : 22;
        if (img.complete && img.naturalWidth > 0) {
          armKenBurns(img, secs);
        } else {
          var started = false;
          var startIt = function () {
            if (started) return;
            started = true;
            armKenBurns(img, secs);
          };
          img.addEventListener('load', startIt);
          /* fallback: if the image never fires load, reveal it anyway */
          setTimeout(startIt, 3500);
        }
      })(kbImgs[i]);
    }

    /* ---- Hero: fill the viewport exactly below the sticky header ---- */
    function setHeroHeight() {
      var hero = document.querySelector('.template-index .slideshow');
      if (!hero) return;
      var offset = 0;
      var secHeader = document.querySelector('.section-header');
      if (secHeader) offset = secHeader.getBoundingClientRect().top + secHeader.offsetHeight;
      document.documentElement.style.setProperty('--pl-hero-offset', offset + 'px');
      var heroSec = document.querySelector('.template-index #MainContent > .shopify-section:first-child');
      if (heroSec) document.documentElement.style.setProperty('--pl-hero-h', heroSec.offsetHeight + 'px');
      var ann = document.querySelector('.template-index .utility-bar');
      if (ann) document.documentElement.style.setProperty('--pl-announce-h', ann.offsetHeight + 'px');
    }
    setHeroHeight();
    if (window.addEventListener) {
      window.addEventListener('resize', setHeroHeight);
      window.addEventListener('load', setHeroHeight);
    }

    /* ---- 滚动期间暂停 hero 动画（Ken Burns），减少覆盖轮播图时的合成压力 ---- */
    var kbPauseTimer = null;
    window.addEventListener(
      'scroll',
      function () {
        document.documentElement.classList.add('pl-scrolling');
        if (kbPauseTimer) clearTimeout(kbPauseTimer);
        kbPauseTimer = setTimeout(function () {
          document.documentElement.classList.remove('pl-scrolling');
        }, 220);
      },
      { passive: true },
    );

    /* ---- 滚轮滚动：逐帧平滑跟随 + 松手后惯性无缝衔接（华歌尔式丝滑，全站生效） ---- */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var scrollVel = 0;         // 惯性速度（px/帧）
      var scrollTarget = window.scrollY;
      var scrollPos = window.scrollY;
      var scrollRaf = null;
      var lastWheelAt = 0;

      function maxScrollY() {
        return document.documentElement.scrollHeight - window.innerHeight;
      }

      function clampY(v) {
        return Math.max(0, Math.min(maxScrollY(), v));
      }

      function scrollStep() {
        var now = performance.now();
        var idle = (now - lastWheelAt) > 60; // 约 3 帧内无滚轮即视为松手
        if (idle) {
          // 松手：惯性立即接管（目标继续前移，画面不停顿）
          scrollTarget += scrollVel;
          scrollVel *= 0.93;
          if (Math.abs(scrollVel) < 0.3) scrollVel = 0;
        }
        scrollTarget = clampY(scrollTarget);
        // 逐帧向目标平滑插值（滚轮格与格之间连续移动，不跳格）
        scrollPos += (scrollTarget - scrollPos) * 0.24;
        scrollPos = clampY(scrollPos);
        // 位置实际变化超过阈值才滚动，避免每帧无效 scrollTo 造成布局抖动
        if (Math.abs(window.scrollY - scrollPos) > 0.4) {
          window.scrollTo({ top: scrollPos, behavior: 'instant' });
        }
        var done = idle && Math.abs(scrollVel) < 0.3 && Math.abs(scrollTarget - scrollPos) < 0.5;
        if (done) {
          scrollRaf = null;
          return;
        }
        scrollRaf = requestAnimationFrame(scrollStep);
      }

      window.addEventListener(
        'wheel',
        function (e) {
          if (e.deltaMode === 1) return; // 行模式（部分触摸板）保留原生滚动
          e.preventDefault();
          lastWheelAt = performance.now();
          // 目标位置即时跟随滚轮（低灵敏度 0.6 倍）
          scrollTarget = clampY(scrollTarget + e.deltaY * 0.6);
          // 累积惯性速度（限幅，避免失控）
          scrollVel += e.deltaY * 0.06;
          if (scrollVel > 30) scrollVel = 30;
          if (scrollVel < -30) scrollVel = -30;
          if (!scrollRaf) scrollRaf = requestAnimationFrame(scrollStep);
        },
        { passive: false },
      );
    }

    /* ---- Slideshow: fade (隐现) 切换，参考华歌尔 ---- */
    var slideshow = document.querySelector('.template-index slideshow-component');
    if (slideshow) {
      var sliderEl = slideshow.querySelector('.slideshow');
      var slides = Array.prototype.slice.call(slideshow.querySelectorAll('.slideshow__slide'));
      var links = Array.prototype.slice.call(slideshow.querySelectorAll('.slider-counter__link'));
      var prevBtn = slideshow.querySelector('[name="previous"]');
      var nextBtn = slideshow.querySelector('[name="next"]');
      var autoplayBtn = slideshow.querySelector('.slideshow__autoplay');
      var speed = (Number(sliderEl.getAttribute('data-speed')) || 5) * 1000;
      var current = 0;
      var timer = null;
      var paused = false;

      function show(i) {
        var prev = slides[current];
        current = ((i % slides.length) + slides.length) % slides.length;
        slides.forEach(function (s, idx) {
          s.classList.toggle('is-active', idx === current);
        });
        links.forEach(function (l, idx) {
          l.classList.toggle('is-active', idx === current);
        });
        // 旧 slide 保留 is-fading 完成 0.9s 渐隐，结束后移除（恢复隐藏，不再参与合成）
        if (prev && prev !== slides[current]) {
          prev.classList.add('is-fading');
          clearTimeout(show._fadeTimer);
          show._fadeTimer = setTimeout(function () {
            prev.classList.remove('is-fading');
          }, 950);
        }
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function play() {
        stop();
        if (slides.length < 2 || paused || document.hidden || sliderEl.getAttribute('data-autoplay') !== 'true') return;
        timer = setInterval(function () { show(current + 1); }, speed);
      }

      links.forEach(function (l, idx) {
        l.addEventListener('click', function (e) { e.preventDefault(); show(idx); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); show(current + 1); });
      if (autoplayBtn) autoplayBtn.addEventListener('click', function (e) { e.preventDefault(); paused = !paused; play(); });

      slideshow.addEventListener('mouseenter', stop);
      slideshow.addEventListener('mouseleave', play);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });

      show(0);
      play();
    }

    /* ---- Scroll reveal ---- */
    var els = document.querySelectorAll('.pl-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < els.length; j++) els[j].classList.add('is-visible');
      return;
    }
    if (reduce) {
      for (var m = 0; m < els.length; m++) els[m].classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  } catch (e) {
    /* fail safe: nothing breaks */
  }
})();
